import BaseWebView from './base_web_view';
import {WEB_VIEW_IDS, WEB_VIEW_INFO, WEB_VIEW_REASON} from './web_view_manager_consts';
import {KEY_NAME} from '../../native/native_const';
import {SYSTEM_EVENTS} from '../../../../events/events';
import Event from '../../../../utils/event';
import ServiceFactory from "../../../service_factory";

class SecondWebView extends BaseWebView {

    static CLASS = 'SecondWebView';

    init(params) {
        super.init(params);
        this._subscribe();
    }

    _subscribe() {
        Event.on(SYSTEM_EVENTS.SECOND_WEB_VIEW_OLD_CALL, this._onOldHybridCall, this);
    }

    /**
     * isValidId
     * return return true if the id of SecondWebView is in range
     */
    isValidId() {
        return WEB_VIEW_IDS.MASTER_ID < this._id && this._id <= WEB_VIEW_IDS.DEPOSIT_WIDGET_ID;
    }

    _onOldHybridCall(data) {
        this.onHybridCall(data);
    }

    /**
     * onHybridCall - call from hybrid
     * data example: {hybridcbfeaturefunc: "WebViewManagerFeature", webid: "1", action: "https://casino-devtouch.888sport.com:82/?reason=0"}
     */
    onHybridCall(data) {

        let reason = this._getReason(data);
        let isClose = ServiceFactory.create().gameReasonService().handleReason(reason);
        if (isClose) {
            this.onclose();
            return;
        }
        switch (reason) {
            case WEB_VIEW_REASON.CLOSE_BUT_CLICKED:// close but clicked
                this.onclose();
                break;

            case WEB_VIEW_REASON.CLIENT_TAPED_ON_VIEW:
                this._onTapped();
                break;

            case WEB_VIEW_REASON.OPEN_LINK:
                this.checkOpenLinks(data);
                break;

            default:
                // maybe should throw an Exception here
                break;
        }
    }

    /**
     * on Tapped - call in order to keep alive the cgp when tapped on secondVewView
     */
    _onTapped() {
        Event.fire(SYSTEM_EVENTS.EXTEND_USER_TIME_TO_LIVE);
    }

    /**
     * get Reason - get the currect reason of incoming msg
     * data example1: tapAction
     * data example2: closebutclicked
     * data example3: https://casino-devtouch.888sport.com:82/?reason=0
     */
    _getReason(data) {

        let val = data[KEY_NAME.ACTION];

        if (undefined === val) {
            return WEB_VIEW_REASON.OPEN_LINK;
        }

        if (WEB_VIEW_INFO.TAP_ON_VIEW === val) {
            return WEB_VIEW_REASON.CLIENT_TAPED_ON_VIEW;
        }

        if (WEB_VIEW_INFO.CLOSE_BUT_CLICKED === val) {
            return WEB_VIEW_REASON.CLOSE_BUT_CLICKED;
        }

        let extractFirstPart = val.split('?')[1]; // gets the first part after the ?

        if ('undefined' === typeof extractFirstPart) {
            return WEB_VIEW_REASON.UN_DEFINED;
        }

        let allowedPattern = /^reason=([0-9]{1,2})/,
            matchedURL = extractFirstPart.match(allowedPattern),
            reasonID = Array.isArray(matchedURL) ? Number(matchedURL[1]) : false;

         return reasonID;
    }

}

export default SecondWebView;